import React from 'react';
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';

const UpdateSourceDropDown = ({ ...props }) => {
  const text = useTextResources();
  const sources = [
    {
      value: true,
      text: text('RMS'),
    },
    {
      value: false,
      text: text('Manual'),
    },
  ];
  return (
    <DropDown
      search={false}
      data={sources}
      placeholder={text('All')}
      valueField='value'
      textField='text'
      selection
      clearable
      {...props}
    />
  );
};

export default UpdateSourceDropDown;
